import { executeRequest } from '@/core/either';
import { http } from '@/core/api';

import type { ApiResult } from '@/core/either';
import type { QuestionLRForm } from '@/types/LegalRepreFormType';
import type { ICustomerPhoneInformation } from '@/shared/onboardingForms/types/personalInformation.type';
import type { AuthHeader } from '@/types/Onboarding';

/**
 * Servicio para gestionar operaciones de onboarding de usuarios.
 * Implementa el patrón Either para manejo de errores.
 */
export const onboardingService = {
  /**
   * Obtiene la pregunta para representante legal conjunto.
   * @returns Promesa con el resultado tipado usando Either (ApiResult).
   */
  getLegalRepresentantQuestion(): Promise<ApiResult<QuestionLRForm>> {
    return executeRequest(() => http.get<QuestionLRForm>('company/b2b/representatives/joint-admin'));
  },

  /**
   * Actualiza el teléfono del cliente.
   * @param dataPersonal - Información del teléfono del cliente.
   * @returns Promesa con el resultado tipado usando Either (ApiResult).
   */
  updateCustomerPhone(dataPersonal: ICustomerPhoneInformation): Promise<ApiResult<void>> {
    return executeRequest(() => http.put<void>('company/b2b/users/phone', dataPersonal));
  },

  /**
   * Valida el teléfono en el proceso de onboarding.
   * @param data - Headers de autenticación para la validación.
   * @returns Promesa con el resultado tipado usando Either (ApiResult).
   */
  postOnboardingValidationPhone(data: AuthHeader): Promise<ApiResult<void>> {
    return executeRequest(() => 
      http.post<void>('company/b2b/users/phone/validate', null, {
        headers: {
          authType: data?.authType,
          authValue: data?.authValue || '',
        },
      })
    );
  },
};